<form name="tableItemEditForm" #tableItemEditForm="ngForm">
  <div class="row">
    <div class="col-sm-8">
      <div class="form-group">
        <label for="Entity"><span class="mandatory">*</span>{{'ClinicalSituation.IncapacityTable.Cause' | translate}}</label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.ClinicalSituation.IncapacityTableEdit.Cause' | translate}}"
               [(ngModel)]="item.cause" name="cause" #cause="ngModel" maxlength="60"
               required>
        <validation-message [control]="cause"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="StartDate"><span class="mandatory">*</span>{{'ClinicalSituation.IncapacityTable.DiagnoseDate' | translate}}</label>
        <div class="form-row">
          <div class="input-group col-sm-12">
            <input #dpStartDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                   placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                   [minDate]="minDate" [maxDate]="maxDate" [(ngModel)]="item.diagnoseDate" name="diagnoseDate"
                   #diagnoseDate="ngModel" required maxlength="10"
                   (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpStartDate)" />
            <div class="input-group-append disable-on-fieldset" (click)="!dpStartDate.isDisabled && dpStartDate.toggle()">
              <span class="input-group-text" id="basic-addon2">
                <i class="icon-calendar"></i>
              </span>
            </div>
            <validation-message [control]="diagnoseDate"></validation-message>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <span *ngIf="!tableItemEditForm.valid && !isEdit" class="text-danger validation_error_all">{{'Generic.ValidationErrorCardAll' | translate}}</span>
</form>



<div class="d-flex justify-content-between mt-4 mb-2">
  <button type="button" class="btn btn-outline-primary disable-on-fieldset" (click)="onRemove(isEdit)"><span
    [ngClass]="isEdit ? 'icon-trash' : 'icon-close'"></span><span>{{isEdit ?  'Remover' : 'Cancelar'}}</span></button>
  <button type="button" aria-label="Aplicar" class="btn btn-primary disable-on-fieldset" (click)="onEdit(isEdit)"><span
      class="icon-check"></span><span>Aplicar</span></button>
</div>
